import { render, staticRenderFns } from "./SalesRecapNew_Details.vue?vue&type=template&id=41739120&"
import script from "./SalesRecapNew_Details.vue?vue&type=script&lang=js&"
export * from "./SalesRecapNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports